import { F0Box, F0Button, F0Heading, F0Text } from '@factorialco/f0-react'
import { Add } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import { useOpenDashboardAction } from 'modules/layout/components/RootLayout/FactorialOneLayout/canvas/dashboards/useOpenDashboardAction'

const DiscoverCardsHeader = () => {
  const { openChatForNewDashboard } = useOpenDashboardAction()

  return (
    <F0Box display="flex" flexDirection="row" alignItems="start" justifyContent="between" gap="md">
      <F0Box display="flex" flexDirection="column" gap="xs" grow>
        <F0Heading variant="heading" content={i18n.t('ai_reports.discover.cards_header.title')} />
        <F0Text
          variant="description"
          content={i18n.t('ai_reports.discover.cards_header.description')}
        />
      </F0Box>
      <F0Button
        variant="default"
        icon={Add}
        label={i18n.t('ai_reports.dashboards.create_report')}
        onClick={openChatForNewDashboard}
      />
    </F0Box>
  )
}

export default DiscoverCardsHeader
